// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1H33r","icon":"styles_icon__1_WEr"};